<template>
  <div>
    <ApuracaoPaginador
      v-if="totalPaginas > 1"
      :pagina="pagina"
      :total="totalPaginas"
      @mudar="mudarPagina"
    />
    <v-data-table
      :headers="headers"
      :items="rows"
      hide-default-footer
      disable-pagination
      dense
      style="white-space: nowrap"
    >
      <template v-slot:body>
        <tbody v-if="gruposExibicao.length">
          <template v-for="(grupo, gi) in gruposExibicao">
            <tr
              v-for="(row, ri) in grupo.rows"
              :key="`${gi}-${ri}`"
              :style="ri === 0 && gi > 0 ? 'border-top: 2px solid rgba(42,87,136,0.12)' : ''"
            >
              <td
                v-if="ri === 0"
                :rowspan="grupo.rows.length"
                style="vertical-align: middle; padding: 4px 10px; border-right: 1px solid rgba(0,0,0,0.08); min-width: 100px; max-width: 140px"
              >
                <div class="caption font-weight-medium d-block">{{ (row.apelido || row.nome_empresa || '').toUpperCase() }}</div>
              </td>
              <td
                v-if="ri === 0"
                :rowspan="grupo.rows.length"
                style="vertical-align: middle; padding: 4px 10px; border-right: 2px solid rgba(42,87,136,0.15); min-width: 130px; max-width: 200px"
              >
                <div class="caption font-weight-bold d-block">{{ row.colaborador }}</div>
                <div class="caption grey--text text--darken-1 d-block" style="font-size: 10px">{{ row.funcao }}</div>
              </td>

              <td style="padding: 2px 10px">
                <BaseLineTableCodDescription :cod="row.id_indicador" :description="row.indicador" />
                <!-- detalhe por faixa: uma linha por faixa com a qtde realizada -->
                <div v-if="row._faixas" class="mt-1" style="display: flex; flex-direction: column; gap: 3px">
                  <div
                    v-for="(f, fi) in row._faixas"
                    :key="fi"
                    class="caption grey--text text--darken-2"
                    style="font-size: 10px; display: flex; align-items: center; gap: 4px; white-space: nowrap"
                  >
                    <span class="font-weight-medium">{{ f.faixa }} dias</span>
                    <span style="color: rgba(0,0,0,0.35)">·</span>
                    <span>{{ formatarQtd(f.realizado) }} veíc × {{ f.bonus | BrazilianCurrency }} = <strong>{{ f.apurado | BrazilianCurrency }}</strong></span>
                  </div>
                </div>
              </td>

              <td class="text-end" style="padding: 2px 10px; white-space: nowrap">
                {{ isOcorrencia(row) ? '1' : formatarValor(row) }}
              </td>
              <td class="text-end" style="padding: 2px 10px; white-space: nowrap">
                {{ formatarRealizado(row) }}
              </td>
              <td class="text-end" style="padding: 2px 10px; white-space: nowrap">
                {{ bonusUnitExibicao(row) | BrazilianCurrency }}
              </td>
              <td class="text-end" style="padding: 2px 10px; white-space: nowrap">
                {{ row.valor_bonus_apurado | BrazilianCurrency }}
              </td>
              <td class="text-center" style="padding: 2px 10px">
                <IconGanhou :ganhou="row.ganhou_item" />
              </td>
              <td class="text-center" style="padding: 2px 10px">
                <IconGanhou :ganhou="row.ganhou_meta" />
              </td>
              <td class="text-end" style="padding: 2px 10px; white-space: nowrap">
                <span :class="statusPagamento(row).valorClass">{{ row.valor_bonus_pagamento | BrazilianCurrency }}</span>
                <v-chip
                  v-if="statusPagamento(row).chip"
                  x-small
                  :color="statusPagamento(row).chip.color"
                  :class="['ml-1 font-weight-bold', statusPagamento(row).chip.textColor]"
                >{{ statusPagamento(row).chip.text }}</v-chip>
              </td>
            </tr>
          </template>
        </tbody>
        <tbody v-else>
          <tr>
            <td :colspan="headers.length" class="text-center grey--text py-4">Sem dados</td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import currencyMixin from "@/mixins/currencyMixin";
import apuracaoTabelaMixin from "@/mixins/apuracaoTabelaMixin";
import BaseLineTableCodDescription from "@/components/shared/BaseLineTableCodDescription";

export default {
  name: "ApuracaoTabelaIndicador",

  components: {
    BaseLineTableCodDescription,
    ApuracaoPaginador: () => import("./ApuracaoPaginador"),
    IconGanhou: () => import("@/components/shared/icons/Ganhou")
  },

  mixins: [currencyMixin, apuracaoTabelaMixin],

  data() {
    return {
      headers: [
        { text: "Empresa",       value: "empresa",               sortable: false },
        { text: "Colaborador",   value: "colaborador",            sortable: false },
        { text: "Indicador",     value: "indicador",              sortable: true  },
        { text: "V. Meta",       value: "valor_meta",             sortable: true  },
        { text: "Realizado",     value: "valor_realizado",        sortable: true  },
        { text: "Bônus Unit.",   value: "valor_bonus",            sortable: true  },
        { text: "Bônus Apurado", value: "valor_bonus_apurado",    sortable: true  },
        { text: "Item",          value: "ganhou_item",            sortable: false },
        { text: "Meta",          value: "ganhou_meta",            sortable: false },
        { text: "Bônus Pago",    value: "valor_bonus_pagamento",  sortable: true  }
      ]
    };
  },

  computed: {
    // Aplica a consolidacao das faixas em cada grupo de colaborador da pagina.
    gruposExibicao() {
      return this.gruposPagina.map(g => ({ rows: this.consolidarFaixas(g.rows) }));
    }
  },

  methods: {
    // "Bônus Unit." da linha principal: para ocorrencia (varias faixas), mostra o
    // menor bonus das faixas (o da 1a faixa); para os demais, o valor_bonus normal.
    bonusUnitExibicao(row) {
      if (row._faixas && row._faixas.length) {
        return Math.min(...row._faixas.map(f => f.bonus));
      }
      return row.valor_bonus;
    },

    // Indicador por ocorrencia vem uma linha por faixa. Junta as faixas do mesmo
    // indicador numa linha (totais) + a lista de faixas (_faixas) pra exibir abaixo.
    consolidarFaixas(rows) {
      const out = [];
      const map = {};
      for (const row of rows) {
        if (!this.temFaixa(row)) {
          out.push(row);
          continue;
        }
        const key = row.id_indicador;
        if (!map[key]) {
          map[key] = {
            ...row,
            _faixas: [],
            valor_realizado: 0,
            valor_bonus_apurado: 0,
            valor_bonus_pagamento: 0,
            ganhou_item: "N",
            ganhou_meta: "N"
          };
          out.push(map[key]);
        }
        const m = map[key];
        m._faixas.push({
          qtde_de: parseFloat(row.qtde_de) || 0,
          faixa: this.formatarFaixa(row),
          realizado: parseFloat(row.valor_realizado) || 0,
          bonus: parseFloat(row.valor_bonus) || 0,
          apurado: parseFloat(row.valor_bonus_apurado) || 0
        });
        m.valor_realizado += parseFloat(row.valor_realizado) || 0;
        m.valor_bonus_apurado += parseFloat(row.valor_bonus_apurado) || 0;
        m.valor_bonus_pagamento += parseFloat(row.valor_bonus_pagamento) || 0;
        if (row.ganhou_item === "S" || row.ganhou_item === true) m.ganhou_item = "S";
        if (row.ganhou_meta === "S" || row.ganhou_meta === true) m.ganhou_meta = "S";
      }
      // Ordena as faixas da menor para a maior (por qtde_de) — o endpoint nao garante ordem.
      out.forEach(r => {
        if (r._faixas) r._faixas.sort((a, b) => a.qtde_de - b.qtde_de);
      });
      return out;
    }
  }
};
</script>
